function LanguageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.81 8.00014C14.8127 9.47114 14.3523 10.9057 13.4941 12.1004C12.6359 13.2951 11.4234 14.1894 10.0286 14.6564C9.30472 14.9052 8.54454 15.0318 7.77916 15.031C7.01574 15.0357 6.2572 14.909 5.53675 14.6564C4.14129 14.1893 2.92797 13.2953 2.06829 12.1009C1.20862 10.9066 0.746094 9.47221 0.746094 8.00063C0.746094 6.52905 1.20862 5.0947 2.06829 3.90033C2.92797 2.70596 4.14129 1.81198 5.53675 1.34481C6.2572 1.09225 7.01574 0.965543 7.77916 0.970246C8.54454 0.96948 9.30472 1.09606 10.0286 1.34481C11.4234 1.81187 12.6359 2.70616 13.4941 3.90088C14.3523 5.09559 14.8127 6.52913 14.81 8.00014Z"
        stroke="currentColor"
        strokeWidth="1.49851"
        strokeMiterlimit="10"
      />
      <path
        d="M11.2969 8.00002C11.2964 8.84588 11.2467 9.69099 11.1481 10.5311C11.001 11.9574 10.6238 13.3505 10.0314 14.6563C9.30758 14.9051 8.54739 15.0317 7.78201 15.0309C7.01859 15.0356 6.26006 14.9089 5.53961 14.6563C4.94718 13.3505 4.57006 11.9574 4.4229 10.5311C4.225 8.84951 4.225 7.15053 4.4229 5.46895C4.57006 4.04262 4.94718 2.64952 5.53961 1.34372C6.26006 1.09115 7.01859 0.964449 7.78201 0.969151C8.54739 0.968385 9.30758 1.09497 10.0314 1.34372C10.6238 2.64952 11.001 4.04262 11.1481 5.46895C11.2467 6.30905 11.2964 7.15416 11.2969 8.00002Z"
        stroke="currentColor"
        strokeWidth="1.49851"
        strokeMiterlimit="10"
      />
      <path
        d="M14.81 8.00099C14.8114 8.56933 14.7443 9.13575 14.6102 9.68804C13.4946 10.1072 12.3326 10.3906 11.1492 10.5321C8.91596 10.8133 6.65624 10.8133 4.42299 10.5321C3.23688 10.3915 2.07211 10.1081 0.954003 9.68804C0.683138 8.57931 0.683138 7.42167 0.954003 6.31295C2.07212 5.89292 3.23689 5.60953 4.42299 5.46892C6.65625 5.18772 8.91595 5.18772 11.1492 5.46892C12.3326 5.61041 13.4946 5.89379 14.6102 6.31295C14.7444 6.86556 14.8114 7.43233 14.81 8.00099Z"
        stroke="currentColor"
        strokeWidth="1.49851"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
export default LanguageIcon;
